document.addEventListener("DOMContentLoaded", function () {
	const diyCarousel = document.querySelector(".diy-image-carousel__swiper");

	if (diyCarousel) {
		const swiper = new Swiper(".diy-image-carousel__swiper", {
			// Optional parameters
			direction: "horizontal",
			loop: true,
			effect: "slide",
			autoplay: { delay: 5000 },
			speed: 1000,
			autoHeight: true,
			keyboard: true,
			slidesPerView: 5.5,
			centeredSlides: true,
			spaceBetween: 15,
			grabCursor: true,
			breakpoints: {
				1440: {
					slidesPerView: 4.5,
					spaceBetween: 15,
				},
				1024: {
					slidesPerView: 3.5,
					spaceBetween: 15,
				},
				768: {
					slidesPerView: 3.25,
					spaceBetween: 15,
				},
				640: {
					slidesPerView: 2.5,
					spaceBetween: 15,
				},
				320: {
					slidesPerView: 1.75,
					spaceBetween: 10,
				},
			},

			// If we need pagination
			pagination: {
				el: ".swiper-pagination",
			},

			// Navigation arrows
			navigation: {
				nextEl: ".swiper-button-next",
				prevEl: ".swiper-button-prev",
			},
		});
	}
});
